/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './button';
export * from './fab';
export * from './icon-button';
export * from './module';



// WEBPACK FOOTER //
// ../../../../../src/material/button/public-api.ts